// extracted by mini-css-extract-plugin
export var actions = "_rw-4";
export var item = "_rw-1";
export var price = "_rw-3";
export var quantity = "_rw-2";
export var table = "_rw-0";